const MY_PLATE_PATTERN =
  /^[A-Z]+\s?[1-9][0-9]{0,3}(?:\s?[A-Z]+)?$/;
const ID_PLATE_PATTERN =
  /^[A-Z]{1,2} \d{1,4}( [A-Z]{1,3})?$/;
export type VehiclePlateContext = {
  countryCode: string;
  cargoProductCode?: string;
};
export function usesMalaysiaPlateRules(ctx: VehiclePlateContext) {
  return ctx.countryCode === "my" || ctx.cargoProductCode === "LION INTERNATIONAL";
}
export function normalizePlateInput(raw: string) {
  return raw.trim().toUpperCase().replace(/\s+/g, " ");
}
export function validateVehiclePlate(
  value: string,
  ctx: VehiclePlateContext
) {
  const normalized = normalizePlateInput(value);
  if (!value) return false;
  if (usesMalaysiaPlateRules(ctx)) return Boolean(MY_PLATE_PATTERN.test(normalized));
  return Boolean(ID_PLATE_PATTERN.test(normalized));
}

export const formatIndonesiaVehicleNo = (value: string)  => {
  // remove special char & uppercase
  value = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

  let region = "";
  let number = "";
  let series = "";

  for (const char of value) {
    // STEP 1 → REGION (max 2 huruf, selama belum ada angka)
    if (!number && !series) {
      if (/[A-Z]/.test(char) && region.length < 2) {
        region += char;
        continue;
      }

      if (/\d/.test(char) && region.length >= 1) {
        number += char;
        continue;
      }
    }

    // STEP 2 → NUMBER (max 4 angka)
    if (number && !series) {
      if (/\d/.test(char) && number.length < 4) {
        number += char;
        continue;
      }

      if (/[A-Z]/.test(char)) {
        series += char;
        continue;
      }
    }

    // STEP 3 → SERIES (max 3 huruf)
    if (series) {
      if (/[A-Z]/.test(char) && series.length < 3) {
        series += char;
      }
    }
  }

  return [region, number, series].filter(Boolean).join(" ");
}

export const formatMalaysiaVehicleNo = (value: string) => {
  // remove special char & uppercase
  value = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

  let prefix = "";
  let number = "";
  let suffix = "";

  for (const char of value) {
    // STEP 1 → PREFIX (max 3 huruf)
    if (!number && !suffix) {
      if (/[A-Z]/.test(char) && prefix.length < 4) {
        prefix += char;
        continue;
      }

      if (/\d/.test(char) && prefix.length >= 1) {
        number += char;
        continue;
      }
    }

    // STEP 2 → NUMBER (max 4 digit)
    if (number && !suffix) {
      if (/\d/.test(char) && number.length < 4) {
        number += char;
        continue;
      }

      if (/[A-Z]/.test(char)) {
        suffix += char;
        continue;
      }
    }

    // STEP 3 → SUFFIX (max 4 huruf)
    if (suffix) {
      if (/[A-Z]/.test(char) && suffix.length < 4) {
        suffix += char;
      }
    }
  }

  return [prefix, number, suffix].filter(Boolean).join(" ");
}

